import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/question.png'


const _hoisted_1 = { class: "value-overview" }
const _hoisted_2 = { class: "overview-title" }
const _hoisted_3 = { class: "output-tooltip" }
const _hoisted_4 = { class: "overview-content" }
const _hoisted_5 = { class: "output-wrapper" }
const _hoisted_6 = { class: "output-content" }
const _hoisted_7 = { class: "item-title" }
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { class: "item-rate" }
const _hoisted_10 = { class: "item-num" }
const _hoisted_11 = { class: "output-wrapper" }
const _hoisted_12 = { class: "output-content" }
const _hoisted_13 = { class: "item-title" }
const _hoisted_14 = { class: "item-name" }
const _hoisted_15 = { class: "item-rate" }
const _hoisted_16 = { class: "item-num" }

import {
  ref,
  onMounted,
  getCurrentInstance,
  computed,
  onUpdated,
} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'valueOverview',
  props: {
  overviewData: {
    type: Object,
    default: () => {
      return {};
    },
  },
},
  setup(__props) {

const props = __props;

// 产值概览echart
const outputEchart = ref();
// 线索概览echart
const leadEchart = ref();

// 产值概览
const outputData = computed(() => {
  return {
    outputSum: (props?.overviewData?.totalOutputValue || "0") + "万",
    outputList: [
      {
        name: "保养线索",
        rate: props.overviewData?.maintenanceLeads?.infoOutputValue || "0.00%",
        value: props.overviewData?.maintenanceLeads?.accessoriesValue || "0",
        itemStyle: {
          color: "#65a7ea",
        },
      },
      {
        name: "轻微碰撞",
        rate: props.overviewData?.faultLeads?.infoMinorOutputValue || "0.00%",
        value: props.overviewData?.faultLeads?.minorOutputValue || "0",
        itemStyle: {
          color: "#6bc7e6",
        },
      },
      {
        name: "严重碰撞",
        rate: props.overviewData?.faultLeads?.infoSeriousOutputValue || "0.00%",
        value: props.overviewData?.faultLeads?.seriousOutputValue || "0",
        itemStyle: {
          color: "#4edfd1",
        },
      },
    ],
  };
});

// 线索概览
const leadData = computed(() => {
  return {
    leadSum: (props?.overviewData?.totalLeadsValue || "0") + "万",
    leadList: [
      {
        name: "保养线索",
        rate: props.overviewData?.maintenanceLeads?.infoLeadsNum || "0.00%",
        value: props.overviewData?.maintenanceLeads?.sendLeadsNum || "0",
        itemStyle: {
          color: "#65a7ea",
        },
      },
      {
        name: "维修线索",
        rate: props.overviewData?.faultLeads?.infoLeadsNum || "0.00%",
        value: props.overviewData?.faultLeads?.sendLeadsNum || "0",
        itemStyle: {
          color: "#6bc7e6",
        },
      },
      {
        name: "保险线索",
        rate: props.overviewData?.accidentLeads?.infoLeadsNum || "0.00%",
        value: props.overviewData?.accidentLeads?.sendLeadsNum || "0",
        itemStyle: {
          color: "#4edfd1",
        },
      },
      {
        name: "续保线索",
        rate: props.overviewData?.insuranceLeads?.infoLeadsNum || "0.00%",
        value: props.overviewData?.insuranceLeads?.sendLeadsNum || "0",
        itemStyle: {
          color: "#63d9a9",
        },
      },
    ],
  };
});

// 获取当前组件实例
const { proxy }: any = getCurrentInstance();
const drawOuputCharts = () => {
  // echarts初始化
  let myOuputChart = proxy.$echarts.init(outputEchart.value);
  // 绘制图表
  const option = {
    title: {
      text: outputData.value.outputSum,
      subtext: "总产值",
      left: "center",
      top: "38%",
      textStyle: {
        fontSize: 22,
        color: "#4D5464",
        align: "center",
      },
      subtextStyle: {
        fontSize: 14,
        color: "#8D939E",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b0}: &nbsp; {c0}万",
    },
    series: [
      {
        type: "pie",
        radius: ["70%", "90%"],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        padAngle: 2,
        label: {
          show: false,
          position: "center",
        },
        labelLine: {
          show: false,
        },
        data: outputData.value.outputList,
      },
    ],
  };
  myOuputChart.setOption(option, true);
  window.addEventListener("resize", () => {
    myOuputChart.resize();
  });
};

const drawLeadCharts = () => {
  // echarts初始化
  let myLeadChart = proxy.$echarts.init(leadEchart.value);
  // 绘制图表
  const option = {
    title: {
      text: leadData.value.leadSum,
      subtext: "总线索",
      left: "center",
      top: "38%",
      textStyle: {
        fontSize: 22,
        color: "#4D5464",
        align: "center",
      },
      subtextStyle: {
        fontSize: 14,
        color: "#8D939E",
      },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b0}: &nbsp; {c0}",
    },
    series: [
      {
        type: "pie",
        radius: ["70%", "90%"],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        padAngle: 2,
        label: {
          show: false,
          position: "center",
        },
        labelLine: {
          show: false,
        },
        data: leadData.value.leadList,
      },
    ],
  };
  myLeadChart.setOption(option);
  window.addEventListener("resize", () => {
    myLeadChart.resize();
  });
};

onMounted(() => {
  console.log("onMounted Pied :>> ", props.overviewData);
  drawOuputCharts();
  drawLeadCharts();
});

onUpdated(() => {
  console.log("onUpdated Pied :>> ", props.overviewData);
  drawOuputCharts();
  drawLeadCharts();
});

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "overview-title-name" }, "产值概览", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "<span>总产值-保养线索：统计下发线索30天内回站车辆配件产值提升=下发线索量 × (进站率-6%) × 客单价520元</br>\n            总产值-轻微碰撞：维修线索故障描述为轻微碰撞且跟进成功的总数量 × 5000元</br>\n            总产值-严重碰撞：维修线索故障描述为严重碰撞且跟进成功的总数量 × 40000元</br>\n            </br>\n            下发线索量：统计开业门店各类线索总的下发线索量</span>",
          "raw-content": "",
          placement: "top"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1)
          ])),
          _: 1,
          __: [0]
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "output-echart",
          ref_key: "outputEchart",
          ref: outputEchart
        }, null, 512),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outputData.value.outputList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "output-item"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.rate), 1)
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.value) + "万", 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: "output-echart",
          ref_key: "leadEchart",
          ref: leadEchart
        }, null, 512),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leadData.value.leadList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "output-item"
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(item.rate), 1)
              ]),
              _createElementVNode("div", _hoisted_16, _toDisplayString(item.value), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})